<template>
    <div class="f-anti">
        <div class="contenaire_monito_score shadow-soft">
            <element-circle-score :score="provider.score" :width="78" :stroke="6" :size="22"></element-circle-score>
        </div>
        <div class="title">
            <h2 class="fs-16 fs-sm-19 ls-1 fw-demi-bold">Monito score for</h2>
            <img class="logo mt-1" :src="provider.logo" />
        </div>
        <ul class="mt-3 f-anti">
            <li @click="anchor01()"><p>Trust & Credibility</p><div class="barre"><div :class="['element_barre',getColorScore(provider.sub_score_01)]" :style="'width: '+provider.sub_score_01*10+'%'  "></div></div><span class="sub_score">{{provider.sub_score_01}}</span></li>
            <li @click="anchor02()"><p>Service Quality</p><div class="barre"><div :class="['element_barre',getColorScore(provider.sub_score_02)]" :style="'width: '+provider.sub_score_02*10+'%'  "></div></div><span class="sub_score">{{provider.sub_score_02}}</span></li>
            <li @click="anchor03()"><p>Customer satisfaction</p><div class="barre"><div :class="['element_barre',getColorScore(provider.sub_score_03)]" :style="'width: '+provider.sub_score_03*10+'%'  "></div></div><span class="sub_score">{{provider.sub_score_03}}</span></li>
            <li @click="anchor04()"><p>Fees & Exchange rates</p><div class="barre"><div :class="['element_barre',getColorScore(provider.sub_score_04)]" :style="'width: '+provider.sub_score_04*10+'%'  "></div></div><span class="sub_score">{{provider.sub_score_04}}</span></li>
        </ul>
        <div class="advices">
            <p :class="['advice',provider.country_score]" v-html=provider.country ></p>
            <p :class="['advice',provider.cost_score]" v-html=provider.cost ></p>
        </div>
        <a v-if="provider.score >= '7.0'" target="_blank" rel="noopener" :href="provider.url" class="btn_cta fw-bold f-anti f-18 ls-1 mt-2">Go to {{provider.name}}</a>
        <a v-if="provider.score < '7.0'" target="_blank" rel="noopener" href="#" class="btn_cta fw-bold f-anti f-18 ls-1 mt-2">Find an alternative to {{provider.name}}</a>
    </div>
</template>

<script>
	import CircleScore from './CircleScore.vue'
	export default {
		props:['provider', 'scrollingActive'],
		components : {
			'element-circle-score' : CircleScore,
		},
        methods : {
            getColorScore(score){
                if(score >= '9.5'){
                  return 'excellent';
                } else if(score >= '8'){
                  return 'good';
                } else if(score >= '6.5'){
                  return 'average';
                } else if(score >= '5.0'){
                  return 'poor';
                } else {
                  return 'bad';
                }
            },

            anchor01(){
                if(this.scrollingActive){
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#anchor01").offset().top - 60
                    }, 1000);
                } else {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(".flex .box:nth-child(1)").offset().top - 20
                    }, 1000);
                } 
            },
            anchor02(){
             if(this.scrollingActive){
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#anchor02").offset().top - 60
                    }, 1000);
                } else {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(".flex .box:nth-child(2)").offset().top - 20
                    }, 1000);
                } 
            },
            anchor03(){
             if(this.scrollingActive){
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#anchor03").offset().top - 60
                    }, 1000);
                } else {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(".flex .box:nth-child(3)").offset().top - 20
                    }, 1000);
                } 
            },
            anchor04(){
              if(this.scrollingActive){
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#anchor04").offset().top - 60
                    }, 1000);
                } else {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(".flex .box:nth-child(4)").offset().top - 20
                    }, 1000);
                } 
            }
        }
	}
</script>

<style lang="scss"> 

.contenaire_monito_score {
    width: 110px;
    height: 110px;
    background: #ffffff;
    right: -24px;
    top: -40px;
    z-index: 10000;
    position: absolute;
    border-radius: 100px;

    .monito_score  {
      margin: 0!important;
      top: 12px!important;
      left: 14px!important;
    }
  }

  .monito_score svg {
      top: 0px!important;
      left: 0px!important;
  }

  .monito_score .score {
    width: 84px!important;
    top: 7px!important;
    left: -3px!important;
  }

  .advice {
        padding-left: 58px;
        padding-right: 28px;
        margin-bottom: 32px;
        margin-top: 52px;
        margin-left: 14px;
        margin-right: 14px;
        position: relative;

        span {
            font-weight: 600;

        }

        &::after {
            content: '';
            width: 155px;
            height: 2px;
            position: absolute;
            top: -28px;
            left: calc(50% - (155px / 2 ));
            background: #E3E3E3;
            opacity: 0.5;
        }

        &.excellent {
            span {
                color: #67a907;
            }

            &::before {     
                content: '';
                width: 20px;
                height: 20px;
                background: url('/public/picto_excellent.svg');
                background-size: contain;
                position: absolute;
                display: block;
                left: 26px;
                top: 1px;
            }
        }

        &.good {
            span {
                color: #78ca00;
            }

            &::before {
                content: '';
                width: 20px;
                height: 20px;
                background: url('/public/picto_good.svg');
                background-size: contain;
                position: absolute;
                display: block;
                left: 26px;
                top: 1px;
            }
        }

        &.average {
           &::before {
                content: '';
                width: 20px;
                height: 20px;
                background: url('/public/picto_average.svg');
                background-size: contain;
                position: absolute;
                display: block;
                left: 26px;
                top: 1px;
            }
        }

        &.poor {
            &::before {
                content: '';
                width: 22px;
                height: 20px;
                background: url('/public/picto_poor.svg');
                background-size: contain;
                background-repeat: no-repeat;
                position: absolute; 
                display: block; 
                left: 25px;
                top: 0px;
            }
        }

        &.bad {
            &::before {
                content: '';
                width: 22px;
                height: 20px;
                background: url('/public/picto_bad.svg');
                background-size: contain;
                background-repeat: no-repeat;
                position: absolute;
                display: block;
                left: 25px;
                top: 0px;
            }
        }
    }
 
   

</style>

<style lang="scss" scoped>
    img.logo {
        max-width: 205px;
        max-height: 50px;
    }

    .title {
        background-color: #f7f7f7;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 8px;
        padding-top: 34px!important;
        padding-bottom: 32px!important;
        clip-path: polygon(100% 0, 100% calc(100% - 16px), 50% 100%, 0 calc(100% - 16px), 0 0);

        h2 {
            color: #535353;
            opacity: 0.8;
            margin-bottom: 0px;
        }
    }

    .btn_cta{
        margin-left: auto;
        margin-right: auto;
        width: calc(100% - 48px);
        font-size: 18px;
        max-width: 430px;
    }


    ul {
        padding-left: 0;
        list-style: none;
        text-align: left;       
        li {
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            color: #353C45;
            padding: 6px 48px 6px 42px;
            letter-spacing: 0.02em;
            transition: all 0.3s ease;

            p {
                opacity: 1!important;
            }

            &:hover {
                p {
                    font-weight: 700;
                }
                
                cursor: pointer;
                position: relative;
            }

            &.active {
                p {
                    font-weight: 700;
                }
                background: #D3F5F5;
                color: #004660;
                position: relative;
                padding-top: 24px;
                padding-bottom: 24px;
                cursor: default;
        
                &:after {
                    content: '';
                    width: 0;
                    height: 0;
                    border-top: 44px solid transparent;
                    border-bottom: 47px solid transparent;
                    border-right: 14px solid #D3F5F5;
                    left: -14px;
                    top: calc(50% - 44px);
                    position: absolute;
                }  
            }
        }
    }

    p {
        font-weight: 600;
        color: #353C45;
        opacity: 1;
        text-align: left;
    }

    
    .sub_score {
        width: 10%;
        display: inline-block; 
        text-align:center;
        position: relative;
        right: -20px;
        font-weight: 700;
    }

    .barre {
        width: 90%;
        height: 9px;
        margin-top: 8px;
        border-radius: 5px;
        position: relative;
        background: #D2D1D270;
        display: inline-block;

        .element_barre {
            height: 9px;
            border-radius: 5px;
            position: absolute;
            top: 0;
            left: 0;
        }

        .excellent {
            background-color: #78ca00;
        }

        .good {
            background-color: #00a000;
        }

        .average {
            background-color: #ff9a00;
        }

        .poor {
            background-color: #ff5800;
        }

        .bad {
            background-color: #ff0030;
        }
    }

    @media($tablet_paysage_only) {
        .title {
            width: calc(100% - 40px);
            clip-path: polygon(100% 0, 100% calc(100% - 30px), 50% 100%, 0 calc(100% - 30px), 0 0);

        }
        ul {
            width: 50%;
            display: inline-block;
            vertical-align: middle;
        }

        .advices {
            width: 43%;
            box-sizing: border-box;
            display: inline-block;
            vertical-align: middle;
        }
    }

    @media ($mobile) {
        .contenaire_monito_score {
            right: 14px;
            top: -60px;
        }
         ul {
            width: 100%;
        }


    }

</style> 








// WEBPACK FOOTER //
// src/components/WidgetSliderMonitoScore.vue